module.exports = __webpack_public_path__ + "static/nintendo-8231e11f9eac7930911de99ddd0c2873.jpg";